import React from "react";
import styled from "styled-components";
import { SUBSCRIPTIONS } from "../../CoreLoop";

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--background-color);
  transform: scaleY(var(--score));
  transform-origin: bottom;
  transition: background-color 0.25s ease-in-out;
  z-index: -1;
`;

function ScoreBackground({ coreLoop }) {
  const [score, setScore] = React.useState(0);
  const id = React.useId();
  React.useEffect(() => {
    coreLoop.current.subscribe(SUBSCRIPTIONS.SCORE, id, (data) => {
      setScore(data);
    });
    return () => {
      coreLoop.current.unsubscribe(SUBSCRIPTIONS.SCORE, id);
    };
  }, [id]);

  const backgroundColor = React.useMemo(() => {
    if (score === 1) return "var(--color-green-200)";
    else return "var(--color-amber-200)";
  }, [score]);

  return (
    <Wrapper
      style={{ "--score": score, "--background-color": backgroundColor }}
    />
  );
}

export default React.memo(ScoreBackground);
